import { createRoot } from 'react-dom/client';
import App from 'areas/layout/components/App';
import { appSettings } from './appSettings';
import { datadogLogs } from '@datadog/browser-logs';
import { initCorrelationId } from 'infrastructure/network/correlationId';

import "./scss/shipV3/app.scss"

datadogLogs.init({
  clientToken: appSettings.DataDog.ClientToken,
  site: 'datadoghq.com',
  service: 'payg-web',
  env: appSettings.Environment.Code.toLowerCase(),
  version: appSettings.Version.BuildNumber,
  forwardErrorsToLogs: true,
  useSecureSessionCookie: true,
  beforeSend: (log) => {
    // Discard 404 errors from prepaid auto top-up endpoint, as they are expected when the feature isn't setup.
    if ((log.exception as any)?.status === 404 && (log.request as any)?.url === "/api/v1/billing/prepaid_auto_topup") {
      return false;
    }
    return true;
  },
});

datadogLogs.setGlobalContextProperty('commit', appSettings.Version.SourceVersion)

const baseCorrelationId = datadogLogs.getInternalContext()?.session_id ?? crypto.randomUUID();
const correlationId = baseCorrelationId.startsWith('payg_web_')
  ? baseCorrelationId
  : `payg_web_${baseCorrelationId}`;
initCorrelationId(correlationId);
datadogLogs.setGlobalContextProperty('CorrelationId', correlationId);

console.info(`Pay-As-You-Go Web v${appSettings.Version.BuildNumber} starting (env = ${appSettings.Environment.Code}, commit = ${appSettings.Version.SourceVersion}).`);

const root = createRoot(document.getElementById('root')!);
root.render(<App />);